import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach token from localStorage as fallback for cross-site cookie issues
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smb_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
